import config from "../../config"
import RequestService from "../RequestService"

const fetchTickets = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/tickets`, successCallback, failureCallback)
}

export default fetchTickets;